import TrackingError from './TrackingError.js'

export class SavePageViewHitTrackingError extends TrackingError {}
